module.exports = __webpack_public_path__ + "static/media/DD.4859daa8.gif";